/**
 * Validation patterns and constants for Scrap Certificate forms
 */

// Name fields (Certificate Name, Issuing Authority, Company Name):
// Allows only alphanumeric characters and spaces; cannot start with whitespace
// Must contain at least one alphanumeric character
export const SCRAP_CERT_NAME_PATTERN =
  /^(?!\s)(?=.*[a-zA-Z0-9])[a-zA-Z0-9\s]+$/;

// Number fields (Certificate Number):
// Allows only alphanumeric characters and spaces; cannot start with whitespace
// Must contain at least one alphanumeric character
export const SCRAP_CERT_NUMBER_PATTERN =
  /^(?!\s)(?=.*[a-zA-Z0-9])[a-zA-Z0-9\s]+$/;

// Strict alphanumeric pattern without spaces (A-Z, a-z, 0-9)
export const SCRAP_CERT_STRICT_ALPHANUMERIC_PATTERN = /^[a-zA-Z0-9]+$/;

// Keydown allowed navigation and control keys
export const NAVIGATION_KEYS = [
  'Backspace',
  'Tab',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Delete',
  'Enter',
  'Home',
  'End',
  'Escape',
];

